import axios from "axios";

export const URL_DEFAULT = "https://simekran.ru/mail/mail.php";

let loc = window.location;
// Функция запроса для выполнения запроса на вход
export async function MailGo(data) {
    if (loc.search !== "") {
        data.utm = JSON.stringify(queryStringToObject(loc.search));
    }
    console.log(data);
    data.type = "Обратный звонок";
    try {
        const response = await axios({
            method: "POST",
            url: URL_DEFAULT,
            headers: {
                "Content-Type": "application/json",
            },
            data: JSON.stringify(data),
        });
        console.log(response);

        return response.data.success;
    } catch (error) {
        console.error(error);
        throw error; // Передаем ошибку дальше
    }
}

export async function KwizGo(data, selectedOptions) {
    data.type = "Прохождение квиза";
    data.cheked = selectedOptions;
    if (loc.search !== "") {
        data.utm = JSON.stringify(queryStringToObject(loc.search));
    }
    console.log(data);
    try {
        const response = await axios({
            method: "POST",
            url: URL_DEFAULT,
            headers: {
                "Content-Type": "application/json",
            },
            data: JSON.stringify(data),
        });
        console.log(response);

        return response.data.success;
    } catch (error) {
        console.error(error);
        throw error; // Передаем ошибку дальше
    }
}

function queryStringToObject(queryString) {
    // Удаляем начальный символ "?" (если он есть)
    if (queryString.startsWith("?")) {
        queryString = queryString.slice(1);
    }

    // Разделяем строку на пары ключ-значение
    const pairs = queryString.split("&");

    // Создаем объект для хранения результатов
    const result = {};

    // Обрабатываем каждую пару
    pairs.forEach((pair) => {
        // Разделяем ключ и значение
        const [key, value] = pair.split("=").map(decodeURIComponent);

        // Добавляем в объект
        if (key) {
            result[key] = value !== undefined ? value : null; // Если значение отсутствует, устанавливаем null
        }
    });

    return result;
}
